<h2 mat-dialog-title class="text-center">{{data['title']}}</h2>
<mat-dialog-content>
  <div>
    @if (data.icon) {
      <mat-icon>{{data.icon}}</mat-icon>
    }
    {{data.message}}
  </div>
  <br>
    <!--<div *ngIf="totalPenalitiesAmount == 0 && missingAmount == 0" class="text-center fx-row fx-wrap fx-justify-center fx-items-stretch fx-fill">
    <div>Operazione Trenitalia gratuita</div>
  </div>-->
  @if (totalPenalitiesAmount > 0 || missingAmount > 0 || postSaleFee >0) {
    <div class="price-container fx-column fx-wrap fx-justify-start fx-items-stretch fx-fill">
      <div class="fx-row fx-wrap fx-justify-start fx-items-stretch fx-fill">
        <div class="fx-flex-50">Nuovo:</div>
        <div class="text-right fx-flex-50">
          {{totalValueAmount+missingAmount-totalPenalitiesAmount |currency: 'EUR'}}
        </div>
      </div>
      <div class="fx-row fx-wrap fx-justify-start fx-items-stretch fx-fill">
        <div class="fx-flex-50">Attuale:</div>
        <div class="text-right fx-flex-50">{{totalValueAmount	 | currency:'EUR'}}</div>
      </div>
      <div class="fx-row fx-wrap fx-justify-start fx-items-stretch fx-fill">
        <div class="fx-flex-50">Penale:</div>
        <div class="text-right fx-flex-50">
          {{totalPenalitiesAmount |currency: 'EUR'}}
        </div>
      </div>
      @if (data.postSaleData.additionalCharges) {
        <div class="fx-row fx-wrap fx-justify-start fx-items-stretch fx-fill">
          <div class="fx-flex-50">Operazione:</div>
          <div class="text-right fx-flex-50">
            {{data.postSaleData.additionalCharges.amount.amount |currency: 'EUR'}}
          </div>
        </div>
      }
      @if (postSaleFee>0) {
        <div class="fx-row fx-wrap fx-justify-start fx-items-stretch">
          <div class="fx-flex-50">Diritti Agenzia:</div>
          <div class="text-right fx-flex-50">
            {{postSaleFee |currency: 'EUR'}}
          </div>
        </div>
      }
      @if (data.postSaleData.reversedPaymentRecords.length==0) {
        <div class="fx-row fx-wrap fx-justify-start fx-items-stretch fx-fill">
          <div class="fx-flex-50">Da pagare:</div>
          <div class="text-right fx-flex-50">
            @if (missingAmount + postSaleFee > 0) {
              <strong>{{missingAmount+postSaleFee |currency: 'EUR'}}</strong>
            }
            @if (missingAmount + postSaleFee == 0) {
              <span>{{missingAmount+postSaleFee | currency: 'EUR'}}</span>
            }
          </div>
        </div>
      }
      <!--<div *ngIf="!hasReversedPaymentRecords" class="fx-row fx-wrap fx-justify-start fx-items-stretch fx-fill">
      <div class="fx-flex-50">Totale:</div>
      <div class="text-right fx-flex-50">
        {{totalValueAmount + missingAmount+postSaleFee |currency: 'EUR'}}
      </div>
    </div>-->
    @for (rev of data.postSaleData.reversedPaymentRecords; track rev) {
      <div class="fx-row fx-wrap fx-justify-start fx-items-stretch">
        @if (rev) {
          <div class="fx-flex-50">Da rimborsare:</div>
        }
        @if (rev) {
          <div class="text-right fx-flex-50">
            <strong>{{rev.amount.amount-(postSaleFee/ data.postSaleData.reversedPaymentRecords.length)|currency: 'EUR'}}</strong>
          </div>
        }
      </div>
    }
  </div>
}
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>Annulla</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</mat-dialog-actions>